var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('div',[_c('h3',[_vm._v(_vm._s(_vm.mainHeader))]),_c('p',[_vm._v(_vm._s(_vm.mainStory))])]),(_vm.mainUpdate && _vm.mainUpdate.length > 1)?_c('div',{staticClass:"main-update"},[_c('p',[_c('b',[_vm._v("Päivitys: ")]),_vm._v(" "+_vm._s(_vm.mainUpdate))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }